<template>
    <div class="print-clinic-notes">
        <div class="notes-title">{{ $translate('clinic_notes') }}</div>
        <hr v-for="x in 10" :key="x" class="clinic-note-line" />
    </div>
</template>

<script>
export default {
    name: 'PrintClinicNotes'
}
</script>
<style lang="scss" scoped>
.print-clinic-notes {
    .notes-title {
        font-weight: bold;
    }
    .clinic-note-line {
        margin-top: 3rem;
    }
}
</style>